import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from './useToast';

function resolveErrorMessage(code: string): string {
  // 認証・セッション期限切れ系: ユーザーに再試行を促す
  if (code === 'state_expired' || code === 'jwt_expired') {
    return 'Canva 連携の有効期限が切れました。もう一度お試しください。';
  }
  // エクスポート系: Canva から画像を取得できなかった
  if (
    code === 'export_failed' ||
    code === 'design_creation_failed' ||
    code === 'design_not_found'
  ) {
    return 'Canva からの画像取得に失敗しました。もう一度お試しください。';
  }
  // それ以外（認証失敗、DB エラー、JWT 検証失敗等）はまとめて汎用メッセージ
  return 'Canva 連携でエラーが発生しました。しばらく経ってから再度お試しください。';
}

export function useCanvaResultToast() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const success = params.get('canva_success');
    const error = params.get('canva_error');

    if (!success && !error) return;

    if (success) {
      toast.success('Canva での編集内容を保存しました');
    } else if (error) {
      toast.error(resolveErrorMessage(error));
    }

    params.delete('canva_success');
    params.delete('canva_error');
    // 失敗時に BE が付けるログ用の詳細 (素材 ID を運ぶ detail とは別名)
    params.delete('canva_error_detail');
    const cleanSearch = params.toString();
    navigate(location.pathname + (cleanSearch ? `?${cleanSearch}` : ''), { replace: true });
  }, [location.pathname, location.search, navigate, toast]);
}
